import { ChevronRight, X } from 'lucide-react'

interface ChatIntroCalloutProps {
  onTry: () => void
  onDismiss: () => void
}

// Quiet one-time "Try chat" nudge beside the collapsed rail. A small pulsing
// dot signals "new" without shouting; it goes away for good once the user opens
// chat or dismisses it (persisted per user).
export default function ChatIntroCallout({
  onTry,
  onDismiss,
}: ChatIntroCalloutProps) {
  // top-5 lines the pill up with the "Chat" mark; mr-4 clears the main
  // content's scrollbar, which sits just left of the rail.
  return (
    <div className="absolute right-full top-5 z-20 mr-4 motion-safe:animate-slide-up-fade">
      <div className="flex items-center rounded-full border bg-popover py-1 pl-2.5 pr-1.5 text-foreground shadow-md">
        <button
          type="button"
          onClick={onTry}
          className="group flex cursor-pointer items-center gap-1.5 whitespace-nowrap text-sm"
        >
          <span className="relative flex h-1.5 w-1.5" aria-hidden>
            <span className="absolute inline-flex h-full w-full rounded-full bg-violet-500/70 motion-safe:animate-ping" />
            <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-violet-500" />
          </span>
          <span className="font-medium">Try chat</span>
          <ChevronRight className="h-4 w-4 text-muted-foreground transition-transform group-hover:translate-x-0.5" />
        </button>
        <button
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss"
          className="ml-0.5 flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-foreground/10 hover:text-foreground"
        >
          <X className="h-3 w-3" aria-hidden />
        </button>
      </div>
    </div>
  )
}
